import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';

const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getDashboardListAPI = async (token) => {
    try {
        const response = await API.get('admin/dashboard', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};